import type { ReactNode } from 'react';
import cn from 'classnames';

import IconChevronRight16 from '@warp-ds/icons/react/chevron-right-16';

import type { AutocompleteOption, AutocompleteProps } from '../../../../types/index';
import { replaceDashWithComma } from '../../../../util/formatting';

import styles from './AutocompleteOptionItem.module.css';

interface AutocompleteOptionItemProps {
    option: AutocompleteOption;
    index: number;
    id: string;
    selected: number;
    vertical: AutocompleteProps['vertical'];
    departure?: boolean;
    onClick: () => void;
    onHover: () => void;
    icon: ReactNode | null;
    defaultView?: boolean;
}

export function AutocompleteOptionItem({
    option,
    index,
    id,
    selected,
    vertical,
    onClick,
    onHover,
    icon,
    defaultView = false,
}: AutocompleteOptionItemProps) {
    return (
        // biome-ignore lint/a11y/useFocusableInteractive: option is not directly focusable — selection is managed via input with aria-activedescendant
        <li
            id={`${id}-option-${index}`}
            // biome-ignore lint/a11y/noNoninteractiveElementToInteractiveRole: <li> is given role="option" as required by the ARIA listbox pattern
            role="option"
            aria-selected={selected === index}
            data-testid={`${id}-option-${index}`}
            className={cn(styles['autocomplete-item'], 'flex flex-row items-center cursor-pointer gap-8', {
                's-bg-primary-subtle': selected === index,
                'flex-row justify-between': vertical === 'fhh',
            })}
            onClick={onClick}
            onMouseOver={onHover}>
            {icon}
            <span title={option.text} className={styles['autocomplete-item__text']}>
                {replaceDashWithComma(option.text)}
            </span>
            {option.count && <span className="font-bold">{option.count}</span>}
            {defaultView && <IconChevronRight16 />}
        </li>
    );
}
